import { createSignal } from 'solid-js';
import { TranslationsEn } from '~/locales/translationEn';
import { TranslationsMx } from '~/locales/translationMx';
import { TranslationsZh } from '~/locales/translationZh';

type TranslationDict = Record<keyof typeof TranslationsEn, string>;

export const translations = {
  en: TranslationsEn,
  mx: TranslationsMx,
  zh: TranslationsZh,
} as const satisfies Record<'en' | 'mx' | 'zh', TranslationDict>;

export type LanguageCode = keyof typeof translations;
export type TranslationKeys = keyof (typeof translations)['en'];

export const TranslationKeys = new Proxy({} as Record<TranslationKeys, TranslationKeys>, { get: (_target, prop: string) => prop });

export const languageOptions = [
  { id: 'en', label: 'English', img: '/assets/icons/english.png' },
  { id: 'mx', label: 'Español', img: '/assets/icons/mexican.png' },
  { id: 'zh', label: '中文', img: '/assets/icons/chinese.png' },
] as const;

const [lang, setLang] = createSignal<LanguageCode>(
  (typeof window !== 'undefined' && (localStorage.getItem('locale') as LanguageCode)) || 'en'
);

export const currentLanguage = lang;

export const useLocalization = () => {
  const changeLanguage = (code: LanguageCode) => {
    localStorage.setItem('locale', code);
    setLang(code);
  };

  const t = (key: TranslationKeys, params: Record<string, unknown> = {}) => {
    let text: string = (translations[currentLanguage()] as TranslationDict)[key] ?? key;
    for (const [k, v] of Object.entries(params)) {
      text = text.replaceAll(`{${k}}`, String(v));
    }
    return text;
  };

  return { t, changeLanguage, currentLanguage };
};
